
/**
 * @param idArray
 */
export function hideElement(idArray) {
    for (let i = 0; i < idArray.length; i++) {
        const elements = document.querySelectorAll("[id=" + idArray[i] + "]")
        elements.forEach(element => {
            if (element) {
                element.style.display = 'none';
            }
        })
    }
}

export function showElement(idArray) {
    for (let i = 0; i < idArray.length; i++) {
        const elements = document.querySelectorAll("[id=" + idArray[i] + "]")
        elements.forEach(element => {
            if (element) {
                element.style.removeProperty("display");
            }
        })
    }
}


/**
 * Fuegt einer Liste von Elementen anhand ihrer ID eine neue CSS-Klasse hinzu
 * @param classname
 * @param idArray
 */
export function addClassToElementsById(classname, idArray) {
    for (let i = 0; i < idArray.length; i++) {
        const element = document.getElementById(idArray[i]);
        if (element) {
            element.classList.add(classname);
        }
    }
}

/**
 * Nimmt bestimmte css Klasse eines Elementes raus
 * @param classname
 * @param id
 */
export function removeClassFromElement(classname, id) {
    const element = document.getElementById(id);
    if (element) {
        element.classList.remove(classname);
    }
}

export function setReadOpacityForElementsById(idArray, isRead) {
    idArray.forEach(id => {
        const teaser = document.getElementById(id);
        if (!teaser) {
            return;
        }

        teaser.querySelectorAll('[data-read-opacity]').forEach(element => {
            element.classList.toggle(element.dataset.readOpacity, isRead);
        });
    });
}

/**
 * Checke ob wir im Iframe sind
 * @returns void
 */
export function isIframe() {
    return window.self !== window.top
}

export function getIntersectingElements(firstList, secondList) {
    const intersectingElements = [];
    const firstListAsAnObject = {};

    // O(n)
    for (let item of firstList) {
        firstListAsAnObject[`${item}`] = item;
    }

    // O(n)
    for (let item of secondList) {
        // O(1)
        if (firstListAsAnObject[item]) {
            intersectingElements.push(item);
        }
    }

    return intersectingElements;
}

export function getNonIntersectingElements(firstList, secondList) {
    const nonIntersectingElements = [];
    const firstListAsAnObject = {};
    const secondListAsObject = {};

    // O(n)
    for (let item of firstList) {
        firstListAsAnObject[`${item}`] = item;
    }

    // O(n)
    for (let item of secondList) {
        secondListAsObject[`${item}`] = item;
    }

    // O(n)
    for (let item of secondList) {
        // O(1)
        if (!firstListAsAnObject[item]) {

            nonIntersectingElements.push(item);
        }
    }

    // O(n)
    for (let item of firstList) {
        // O(1)
        if (!secondListAsObject[item]) {
            nonIntersectingElements.push(item)
        }
    }

    return nonIntersectingElements;
}


export function isLoggedIn() {
    if (typeof IwwUserdata !== 'undefined') {
        if (IwwUserdata.USERDATA.email !== undefined) {
            return IwwUserdata.USERDATA.email.length > 0
        } else if (IwwUserdata.USERDATA.vorname !== undefined) {
            // Fallback überprüfung
            return IwwUserdata.USERDATA.vorname.length > 0
        }
    } else {
        return false
    }
}
